import { configs } from "../configs";
import { IGeneralConfig } from "../configs/general/general.types";
import { getDomain } from "./getTld";

const DEFAULT_META = {
  title: "Finero",
  description: ""
};

export const getRootMetadata = () => {
  const tld = getDomain();
  const variant = process.env.REACT_APP_VARIANT || "v0";
  const generalConfigs = configs.general as Record<string, IGeneralConfig>;
  const config = generalConfigs[tld];
  const meta = config?.meta;

  if (!meta) {
    return DEFAULT_META;
  }

  // Если вариант существует, возвращаем его, иначе fallback на v0
  if (meta.variants && meta.variants[variant]) {
    return meta.variants[variant];
  }

  return {
    title: meta.title,
    description: meta.description
  };
};
